export default function ToggleMidiMapMode(actionContext) {
	return actionContext.dispatch('TOGGLE_MIDI_MAP_MODE', {});
}